import Button from 'common/components/button'

type Props = {
  onClickNext?: () => void
  onClose: () => void
  isLoading?: boolean
  nextButtonName?: string
  isNextButtonLoading?: boolean
  isNextButtonDisabled?: boolean
  errorsCount?: number
  isCancelDisabled?: boolean
}
const Footer = ({
  onClose,
  onClickNext,
  nextButtonName = 'Next',
  isNextButtonLoading: isLoading,
  isNextButtonDisabled: isDisabled,
  errorsCount = 0,
  isCancelDisabled,
}: Props) => {
  return (
    <div className="flex justify-end items-center mt-4 mx-6 gap-4">
      {errorsCount > 0 && (
        <span className="mr-4 text-red-400 font-medium text-base">
          {errorsCount === 1
            ? `1 Mismatch, please fix 🤯`
            : `${errorsCount} Mismatches, please fix 🤯`}
        </span>
      )}
      <Button
        variant="danger"
        onClick={() => onClose()}
        disabled={isCancelDisabled}
      >
        Cancel
      </Button>
      {onClickNext && (
        <Button
          variant="primary"
          disabled={isDisabled}
          loading={isLoading}
          onClick={onClickNext}
        >
          {isLoading ? 'Processing...' : nextButtonName}
        </Button>
      )}
    </div>
  )
}

export default Footer
